/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublicKeyAuthenticator
 */
export interface PublicKeyAuthenticator {
    /**
     * Base64-encoded AAGUID of the authenticator device
     * @type {string}
     * @memberof PublicKeyAuthenticator
     */
    aaguid: string;
    /**
     * 
     * @type {number}
     * @memberof PublicKeyAuthenticator
     */
    sign_count?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PublicKeyAuthenticator
     */
    clone_warning?: boolean;
}

/**
 * Check if a given object implements the PublicKeyAuthenticator interface.
 */
export function instanceOfPublicKeyAuthenticator(value: object): value is PublicKeyAuthenticator {
    if (!('aaguid' in value) || value['aaguid'] === undefined) return false;
    return true;
}

export function PublicKeyAuthenticatorFromJSON(json: any): PublicKeyAuthenticator {
    return PublicKeyAuthenticatorFromJSONTyped(json, false);
}

export function PublicKeyAuthenticatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicKeyAuthenticator {
    if (json == null) {
        return json;
    }
    return {
        
        'aaguid': json['aaguid'],
        'sign_count': json['sign_count'] == null ? undefined : json['sign_count'],
        'clone_warning': json['clone_warning'] == null ? undefined : json['clone_warning'],
    };
}

export function PublicKeyAuthenticatorToJSON(json: any): PublicKeyAuthenticator {
    return PublicKeyAuthenticatorToJSONTyped(json, false);
}

export function PublicKeyAuthenticatorToJSONTyped(value?: PublicKeyAuthenticator | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'aaguid': value['aaguid'],
        'sign_count': value['sign_count'],
        'clone_warning': value['clone_warning'],
    };
}

